import { loadingAsyncState } from "widgets-for-react";
import { getNews } from "./newsOverviewApi";
export const initialNewsResponse = {
    totalResults: 0,
    news: []
};
export const initialState = (props)=>({
        newsLoader: loadingAsyncState(getNews(1, props.pageSize), initialNewsResponse),
        currentPage: 1
    });
export const resultsClass = "news-results";
